/**
 * Theme colors for website.
 */

export const VoiceUpColors = {
    white: "#ffffff",
    black: "#000000",
    grey: "#A9A9A9",
    altGrey: "#c2c2c2",
    darkGrey: "#494949",
    lightGrey: "#F1F1F1",
    gold: "#D9A47D",
    purple: "#432A3F",
};
